import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.1/js/sparta-global-functions-utility";
import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import Handlebars from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import spartaTransportUtility from "utilities/global/sparta-transport-utility/4.0.2/js/sparta-transport-utility";
import spartaBootstrapUtility from "utilities/global/sparta-bootstrap-utility/4.2.3/js/sparta-bootstrap-utility";
import spartaMessageUtility from "utilities/global/sparta-messaging-utility/2.1.5/js/sparta-messaging-utility";
import spartaRequireUtility from "utilities/global/sparta-require-utility/2.1.3/js/sparta-require-utility";
import spartaExperienceUtility from "utilities/global/sparta-experience-utility/2.4.2/js/sparta-experience-utility";
import moduleContainer from "utilities/helpers/module-container/3.2.1/js/module-container";
import * as jcrUtility from "utilities/global/jcr-utility/1.0.2/js/jcr-utility";
export default class Communicator {
    constructor(options) {
        let defaults = {
            public: "document",
            $public: $(),
            private: "",
            $private: $(),
            namespace: "generic"
        };
        this.settings = {};
        this.settings.events = defaults;
        $.extend(this.settings, options);
        this.communication = this.settings.events;
        this.communication.$private = this.settings.$target;
        this.communication.$public = $(this.communication.public);
    }

    beacon(action, params) {



        let utilities = {
          array: {
            slice: function( array ) {
              return Array.prototype.slice.apply(
                array, Array.prototype.slice.call( arguments, 1 )
              );
            },

            remove: function( array, item ) {
              var i, l = array.length;
              for ( i = 0; i < l; i++ ) {
                if ( array[ i ] === item ) {
                  array.splice( i, 1 );
                  i--;
                }
              }
            }
          },  

          functional: function( f ) {
            var slice = utilities.array.slice,
              prepended = [],
              appended = [],
              boundTo = null,
              before,
              after;

            function wrapper() {
              if ( before != null ) {
                before.apply( null, arguments );
              }

              var result = f.apply( boundTo, prepended.concat( slice( arguments ), appended ) );

              if ( after != null ) {
                after.call( null, result );
              }

              return result;
            }

            wrapper.bindTo = function( to ) {
              boundTo = to;
              return wrapper;
            };

            wrapper.append = function() {
              appended = slice( arguments );
              return wrapper;
            };

            wrapper.prepend = function() {
              prepended = slice( arguments );
              return wrapper;
            };

            wrapper.before = function( f ) {
              before = f;
              return wrapper;
            };

            wrapper.after = function( f ) {
              after = f;
              return wrapper;
            };

            return wrapper;
          }
        }


        if (typeof params.context !== "string") return;
        let $location = (params.scope === "public") ? this.communication.$public : this.communication.$private;
        if (action === "listen" && typeof params.callback === "function") {
            $location.on(params.context + "." + this.communication.namespace, utilities.functional(params.callback).bindTo(params.caller));
        }
        if (action === "emit") {
            $location.trigger(params.context + "." + this.communication.namespace, [params.data]);
        }
    }

    listen(params) {
        this.beacon("listen", params);
    }

    emit(params) {
        this.beacon("emit", params);
    }
}